import {
  FETCH_REFERRALS_REQUEST,
  FETCH_REFERRALS_SUCCESS,
  FETCH_REFERRALS_FAILURE,
} from "../actions/types";

const initialState = {
  referral_users: [],
  page: 1,
  size: 10,
  count: 0,
  loading: false,
  error: null,
  message: "",
};

const referralReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFERRALS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_REFERRALS_SUCCESS:
      return {
        ...state,
        loading: false,
        referral_users: action.payload.users,
        page: action.payload.page,
        size: action.payload.size,
        count: action.payload.count,
        message: "Referral stats loaded successfully",
      };

    case FETCH_REFERRALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default referralReducer;